import React from 'react';
import styled from 'styled-components';
import { Icon } from '~/components';
import { colors } from '~/styles';

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 2rem;
    text-align: center;
  `,

  Heading: styled.h2`
    font-size: 1.5rem;
    font-weight: 700;
    color: ${colors.black};
    margin-bottom: 0.5rem;
    line-height: 1.3;
  `,

  Subtext: styled.p`
    font-size: 0.875rem;
    color: ${colors.grey40};
    margin-bottom: 1.5rem;
  `,

  Capabilities: styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
    margin-bottom: 1.5rem;
    width: 100%;
    max-width: 320px;
  `,

  Capability: styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    border-radius: 999rem;
    background: ${colors.white};
    border: 1px solid ${colors.grey5};
  `,

  CapabilityIcon: styled.div`
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    flex-shrink: 0;
    background: ${({ $bg }) => $bg};
    color: ${colors.white};
  `,

  CapabilityText: styled.span`
    font-size: 0.8125rem;
    color: ${colors.black};
    text-align: left;
  `,
};

export default function WelcomeState() {
  return (
    <S.Container>
      <S.Heading>
        Welcome to
        <br />
        Ruddr Intelligence
      </S.Heading>
      <S.Subtext>I can help you with all kinds of things:</S.Subtext>
      <S.Capabilities>
        <S.Capability>
          <S.CapabilityIcon $bg={colors.success}>
            <Icon icon="file-alt" type="far" />
          </S.CapabilityIcon>
          <S.CapabilityText>Quickly summarize a report</S.CapabilityText>
        </S.Capability>
        <S.Capability>
          <S.CapabilityIcon $bg={colors.primary}>
            <Icon icon="search" />
          </S.CapabilityIcon>
          <S.CapabilityText>Search for anything you need</S.CapabilityText>
        </S.Capability>
        <S.Capability>
          <S.CapabilityIcon $bg={colors.danger}>
            <Icon icon="stopwatch" type="far" />
          </S.CapabilityIcon>
          <S.CapabilityText>View your time and expenses</S.CapabilityText>
        </S.Capability>
      </S.Capabilities>
    </S.Container>
  );
}
